var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavArrowIcon = function SvgNavArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 7a1 1 0 0 0 0 2zm26.207 1.707a1 1 0 0 0 0-1.414L20.843.929a1 1 0 1 0-1.414 1.414L25.086 8l-5.657 5.657a1 1 0 0 0 1.414 1.414zM1 8v1h25.5V7H1z"
  })));
};
export default SvgNavArrowIcon;